import { environment } from 'src/environments/environment';

export type RestaurantImageProfile = 'card' | 'hero' | 'mobile';

/** Only the existing public restaurant-image endpoint supports these profiles. */
function restaurantImageEndpoint(value: string): URL | null {
  try {
    const url = new URL(value, environment.apiRoot);
    const api = new URL(environment.apiRoot);
    if (url.origin !== api.origin || !/\/GetImageForMembershipBranch\/?$/i.test(url.pathname)) return null;
    const keys: string[] = [];
    url.searchParams.forEach((_value, key) => keys.push(key.toLowerCase()));
    return keys.includes('branchid') && keys.includes('imagename') ? url : null;
  } catch { return null; }
}

/** The original URL remains untouched until the matching backend is deployed. */
export function restaurantImageUrl(originalUrl: string | null | undefined, profile: RestaurantImageProfile): string | null {
  if (!originalUrl) return null;
  if (!environment.restaurantImageProfilesEnabled) return originalUrl;
  const url = restaurantImageEndpoint(originalUrl);
  if (!url) return originalUrl;
  url.searchParams.set('profile', profile);
  return url.href;
}

export function isRestaurantImageProfileUrl(value: string | null | undefined): boolean {
  if (!value) return false;
  const profile = restaurantImageEndpoint(value)?.searchParams.get('profile');
  return profile === 'card' || profile === 'hero' || profile === 'mobile';
}
